<script lang="ts">
	import type { LinkProps } from "./LinkProps.js";
	import { generateLinkClasses } from "./LinkClasses.js";
	import AriaText from "./AriaText.svelte";
	import ButtonIcon from "./ButtonIcon.svelte";

	type $$Props = LinkProps;

	$: ({
		asButton = false,
		noUnderline = false,
		icon,
		iconFront = false,
		iconClass,
		iconGap,
		linkClass,
		disabled = false,
		variant,
		linkVariant,
		...restProps
	} = $$restProps as $$Props);

	$: linkClasses = [restProps.class, generateLinkClasses({ variant, linkClass, linkVariant, asButton, noUnderline })]
		.filter(Boolean)
		.join(" ");
</script>

<a
	{...restProps}
	class={linkClasses}
	href={restProps.href}
	on:click
	aria-disabled={!restProps.href || disabled}
	role={restProps.href ? "link" : "none"}
	rel={restProps.target === "_blank" ? "noopener noreferrer" : restProps.rel}
>
	<span class="z-10">
		<span
			class={`relative inline-block ${variant === "underline" ? "hover:!underline" : ""} ${iconGap ?? (variant === "tertiary" ? "mr-4" : "mr-5")}`}
		>
			<AriaText aria={restProps["aria-label"] ?? ""}>
				<slot />
			</AriaText>

			{#if variant === "tertiary" && !noUnderline}
				<span
					class="absolute inset-x-0 bottom-0 h-px origin-left scale-x-0 bg-current transition-transform duration-300 ease-out group-hover:scale-x-100"
				></span>
			{/if}
		</span>
	</span>

	{#if icon && !iconFront && variant !== undefined}
		<ButtonIcon {icon} {disabled} {iconClass} {variant} />
	{/if}
</a>
